import { render, staticRenderFns } from "./edit-production-station.vue?vue&type=template&id=4c7a371a&scoped=true"
import script from "./edit-production-station.vue?vue&type=script&lang=ts"
export * from "./edit-production-station.vue?vue&type=script&lang=ts"
import style0 from "./edit-production-station.vue?vue&type=style&index=0&id=4c7a371a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a371a",
  null
  
)

export default component.exports